export const getAccessToken = (): string | undefined => {
	// const storage = getAuthStorage();
	const authStore = localStorage.getItem('authStore');
	return (authStore && JSON.parse(authStore)?.state?.accessToken) ?? undefined;
};
